import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, RouterLink],
})
export class LogoutComponent implements OnInit {


  APP_SETTINGS;
  external:boolean;

  constructor () {
    this.external = false;
  }

  ngOnInit() {
    
    this.APP_SETTINGS = APP_SETTINGS;

    if ( this.APP_SETTINGS.isExternal == 'true' ) {
      this.external = true;
    } else {
      this.external = false;
    }

  }

}
